const GTQ = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'GTQ',
  });

export const currency={"GTQ":GTQ};